/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RevenueIcon = ({ width = 24, height = 24, hidden = false, title = 'Revenue' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 23.658V33a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V21.9l-4.27 3.493ZM2 33a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V20.7l-6 5.139ZM10 18.981V33a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V21.658l-4.211-4.211ZM26 20.259V33a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V20.769l-2.8-3.13Z"
    />
    <path
      d="m24.6 8.833 2.169 2.427-6.631 5.4-7.7-7.7a.5.5 0 0 0-.679-.026L2 17.289v5.267l9.895-8.481 7.651 7.651a.5.5 0 0 0 .67.034l9.056-7.814 1.856 2.195a.5.5 0 0 0 .872-.333V8h-7.03a.5.5 0 0 0-.37.833Z"
    />
  </svg>`;
};
